import { useTranslation } from 'react-i18next';
import { FormItem, Select } from 'Components';
import { useFormikContext } from 'formik';
import { AddUserValues } from 'Pages/User/User.types';
import { SelectProps } from 'Components/Form/Select/Select';
import { roleToOption } from 'Pages/User/EditUser/EditUser.helpers';
import { sortBy } from 'lodash';
import { useUserContext } from '../UserContext';
import { translateTInfo } from 'i18n/i18n.helpers';
import { Checkbox } from 'antd';

const FIELD_NAME = 'primarySystemRoleId';

interface RoleFieldProps {
	isProfile?: boolean;
}
function RoleField(props: RoleFieldProps) {
	const { t } = useTranslation();
	const {
		values,
		setFieldValue,
		getFieldMeta,
		setFieldTouched
	} = useFormikContext<AddUserValues>();
	const meta = getFieldMeta(FIELD_NAME);
	const { systemRoles, systemRolesList } = useUserContext();

	const onChange: SelectProps['onChange'] = (_, option) => {
		const options = option as AddUserValues['primarySystemRoleId'];

		setFieldValue(
			FIELD_NAME,
			sortBy(
				// enumarate object keys to avoid form field redundantly being changed
				// due to additional fields not stated in initial values
				options.map((opt) => ({
					key: opt.key,
					label: opt.label,
					value: opt.value,
					data: opt.data
				})),
				(option) => !option.data.isPrimary
			)
		);
	};

	const currentValue = values.primarySystemRoleId;
	const currentValueRole = currentValue?.find((item) => item.data.isPrimary);

	const error = meta.touched ? meta.error : undefined;
	const isLoading = systemRoles.loading;
	return (
		<FormItem
			label={t('user.primarySystemRoleId')}
			required
			validateStatus={(error && 'error') || undefined}
			help={translateTInfo(error, t)}
		>
			<Select
				mode="multiple"
				className={`custom-multi-select ${(currentValue?.length || isLoading) ? "" : "show-icon"}`}
				placeholder={t('profile.general.placeholders.role')}
				loading={isLoading}
				labelInValue
				onChange={onChange}
				disabled={props.isProfile || isLoading}
				value={currentValue}
				optionFilterProp="label"
				showSearch
			>
				{systemRolesList?.map((role) => {
					const option = roleToOption(role);
					const disabled = option.data.isPrimary && currentValueRole && option.key !== currentValueRole?.key;
					const isActive = (currentValue || []).some(item => item.key === option.key);
					return (
						<Select.Option {...option} disabled={disabled}>
							<Checkbox checked={isActive} disabled={disabled} style={{ pointerEvents: 'none' }}>{option.label}</Checkbox>
						</Select.Option>
					);
				})}
			</Select>
		</FormItem>
	);
}

export default RoleField;
